// extracted by mini-css-extract-plugin
export default {"container":"m1-z","list":"n1-z"};